import { Card, Chip, Grid, IconButton, Link, Typography } from '@mui/joy';
import { FC } from 'react';
import { IDataLinkProps } from '../../types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { deleteLink, extractURLDomain } from '../../controllers/userDataController';
import DeleteIcon from '@mui/icons-material/Delete';
import { useUserDataDispatchContext } from '../../LinkDataStore/Context';
import { useSnackbarDispatch } from '../../SnackbarDataStore/Context';
import { setSnackbar } from '../../controllers/snackController';

const CategoryLinkContainer: FC<IDataLinkProps> = ({ data, categoryId, shared }) => {

	const userDataDispatch = useUserDataDispatchContext();
	const snackbarDispatch = useSnackbarDispatch();

	async function handleLinkDelete() {
		const resp = await deleteLink(userDataDispatch, data._id, categoryId);

		if (resp) {
			setSnackbar(snackbarDispatch, "Link removed !!!", "success");
			return;
		}

		setSnackbar(snackbarDispatch, "Somthing went wrong :(", "error");

	}

	return (
		<Card
			className='flex flex-col align-center w-full'
			sx={{
				paddingY: "5px"
			}}
		>
			<Typography level='body1' noWrap={false}>
				{data.title}
			</Typography>
			<Grid container spacing={2} sx={{
				flexGrow: 1,
				marginY: "5px",
				paddingRight: "5px"
			}}>
				<Grid xs={shared ? 10 : 8}>
					<Chip variant='outlined'>{extractURLDomain(data.url)}</Chip>
				</Grid>
				<Grid xs={2}>
					<Link href={data.url} target="_blank">
						<IconButton sx={{ padding: "0 10px" }} variant='plain' color='neutral' size='sm'>
							<OpenInNewIcon />
						</IconButton>
					</Link>
				</Grid>
				{!shared && <Grid xs={2}>
					<IconButton onClick={handleLinkDelete} sx={{ padding: "0 10px" }} variant='plain' color='neutral' size='sm' >
						<DeleteIcon />
					</IconButton>
				</Grid>}
			</Grid>
		</Card>
	)
}

export default CategoryLinkContainer;